import {
  Brain, Heart, Wind, Shield, Activity, Users, Award, Sparkles,
  UserPlus, Calendar, FileText, TrendingUp, Target, Clipboard,
  HeartHandshake, BookOpen
} from 'lucide-react';

export const iconMap = {
  Brain,
  Heart,
  Wind,
  Shield,
  Activity,
  Users,
  Award,
  Sparkles,
  UserPlus,
  Calendar,
  FileText,
  TrendingUp,
  Target,
  Clipboard,
  HeartHandshake,
  BookOpen
};
